
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolgatpuritaxi() {



    const cardData =
    {
        keyword: 'Pune to Igatpuri Taxi',
        heading: 'Platinum24 Cabs: Pune to Igatpuri Taxi',
        headingDescription: ' Platinum24 Cabs offers reliable Pune to Igatpuri Taxi services, perfect for weekend getaways, hill-station retreats, and leisure trips. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable and safe journey through the scenic Western Ghats. With professional chauffeurs, timely pickups, and transparent fares, we make your Pune to Igatpuri travel completely hassle-free. Whether you’re planning to explore vineyards, enjoy trekking trails, or relax in Igatpuri’s serene landscapes, Platinum24 Cabs provides affordable one-way and round-trip options for a smooth and enjoyable travel experience.',

        top: 'Top Places to Visit in Igatpuri with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Vipassana International Academy (Dhamma Giri)",
    "description": "Dhamma Giri in Igatpuri is one of the world’s largest meditation centers for Vipassana. Its golden pagoda and peaceful surroundings attract seekers from across the globe. Visitors can enroll in meditation courses to experience inner peace. The campus is serene, with beautiful architecture blending tradition and modernity. It is an international hub of spiritual growth. Dhamma Giri is Igatpuri’s global center of meditation and mindfulness."
  },
  {
    "title": "Bhatsa River Valley",
    "description": "Bhatsa River Valley is a picturesque spot near Igatpuri surrounded by lush greenery and hills. The river meanders through valleys, creating scenic landscapes. Photographers love capturing its charm, especially during monsoon when clouds float low. Trekkers enjoy trails leading into the valley. It is also a popular picnic destination. Bhatsa Valley is Igatpuri’s natural retreat of beauty and tranquility."
  },
  {
    "title": "Tringalwadi Fort",
    "description": "Tringalwadi Fort, perched at 3,000 feet, offers panoramic views of the Sahyadris. The trek to the fort is moderately easy, making it ideal for beginners. At the top, visitors find a Hanuman temple and caves believed to be Buddhist. Monsoon enhances the fort’s beauty with mist and waterfalls. It is a paradise for history lovers and trekkers. Tringalwadi Fort is Igatpuri’s adventure and heritage destination."
  },
  {
    "title": "Camel Valley",
    "description": "Camel Valley near Igatpuri is famous for its unique camel-shaped cliff and waterfalls. During monsoon, streams cascade down creating a spectacular sight. The valley overlooks the scenic landscape of the Sahyadris. It is a hotspot for photography and nature lovers. The refreshing breeze adds to the charm. Camel Valley is Igatpuri’s natural wonder of monsoon magic."
  },
  {
    "title": "Vihigaon Waterfall",
    "description": "Vihigaon Waterfall, located in a tribal village near Igatpuri, is a hidden gem. Surrounded by forests, the waterfall is perfect for monsoon treks and rappelling adventures. Adventure groups organize waterfall rappelling here, attracting thrill seekers. Villagers sell local snacks and guide tourists. The natural beauty makes it a popular picnic spot. Vihigaon is Igatpuri’s adventurous waterfall escape."
  },
  {
    "title": "Ghantadevi Temple",
    "description": "Ghantadevi Temple is a serene shrine dedicated to Goddess Ghantadevi, located amidst mountains near Igatpuri railway tracks. Devotees believe the goddess protects trains passing through the ghats. The temple offers spiritual peace along with panoramic views of valleys. Festivals and prayers bring vibrant energy here. Surrounded by greenery, it is calm and divine. Ghantadevi Temple is Igatpuri’s sacred spiritual stop."
  },
  {
    "title": "Kalsubai Peak",
    "description": "Kalsubai Peak, Maharashtra’s highest peak at 5,400 ft, is located near Igatpuri. The trek is popular among adventure enthusiasts, offering mesmerizing sunrise and sunset views. A small temple dedicated to Kalsubai Devi is located at the summit. Monsoon makes the trek lush and adventurous. The panoramic views of Sahyadri ranges are unforgettable. Kalsubai is Igatpuri’s crown jewel of trekking."
  },
  {
    "title": "Amruteshwar Temple",
    "description": "Amruteshwar Temple, built in the 9th century, is a stunning stone-carved temple dedicated to Lord Shiva. Located near Bhandardara, it is one of Maharashtra’s hidden architectural treasures. The temple features intricate carvings and ancient sculptures. Surrounded by greenery and rivers, it offers peace and spirituality. Devotees and history lovers admire its charm. Amruteshwar is Igatpuri’s ancient architectural wonder."
  },
  {
    "title": "Bhandardara Dam & Arthur Lake",
    "description": "Located close to Igatpuri, Bhandardara Dam and Arthur Lake are popular weekend getaways. The lake, formed by the Pravara River, is surrounded by hills and forests. Visitors enjoy boating, camping, and stargazing here. Nearby attractions include Randha Falls and Wilson Dam. The calm ambiance attracts both families and couples. Bhandardara is Igatpuri’s scenic lakeside escape."
  },
  {
    "title": "Dhammagiri Pagoda",
    "description": "The Golden Pagoda at Dhamma Giri is Igatpuri’s iconic landmark. Its striking design represents peace and mindfulness. Visitors can walk around the pagoda and admire its architecture. The area is surrounded by gardens and meditation halls. At night, the illuminated structure looks mesmerizing. The pagoda is Igatpuri’s shining symbol of spirituality."
  }
],



     "services": [
    {
      "name": "Pune to Igatpuri Cab Service",
      "description": "Enjoy a comfortable and reliable Pune to Igatpuri Cab Service for your next weekend getaway or business trip. Our well-maintained cabs and trained drivers ensure a smooth journey through the scenic route to Igatpuri, a popular hill station known for its waterfalls, lush landscapes, and spiritual retreats. Whether it’s a one-way trip or a round journey, we offer personalized service to match your schedule, including multiple vehicle options and budget-friendly pricing."
    },
    {
      "name": "Igatpuri Taxi from Pune",
      "description": "Book a premium Igatpuri Taxi from Pune with ease through our online platform or customer care. Perfect for solo travelers, couples, or groups, our taxis come with GPS tracking, professional chauffeurs, and door-to-door pickup and drop services. Whether you're heading to the hill station for relaxation or adventure, enjoy a scenic drive with total peace of mind, thanks to our commitment to punctuality and customer safety."
    },
    {
      "name": "Pune Igatpuri Taxi Booking",
      "description": "Our Pune Igatpuri Taxi Booking service makes planning your trip simple and efficient. Choose from a wide range of vehicles including sedans, SUVs, and luxury cabs. Booking is instant, with real-time availability, transparent pricing, and flexible payment options. Whether you need an urgent ride or want to schedule in advance, our system ensures your taxi is reserved and ready when you need it most."
    },
    {
      "name": "Taxi Service Pune to Igatpuri",
      "description": "Our dedicated Taxi Service Pune to Igatpuri provides a safe, dependable, and comfortable ride to one of Maharashtra’s most serene destinations. Ideal for tourists, families, and corporate clients, we offer full-day, one-way, and return trip options. Drivers are familiar with the route, ensuring efficient travel time, and vehicles are equipped with essential amenities for your convenience and comfort."
    },
    {
      "name": "Igatpuri Cab Rental Pune",
      "description": "Rent a cab from Pune to Igatpuri with our hassle-free Igatpuri Cab Rental service. Choose from economical models to luxury variants, all cleaned and maintained to high standards. This service is suitable for travelers looking for flexible rental durations — whether a few hours, a full day, or overnight. Add-on services like bottled water, music system, and multilingual drivers are available on request."
    },
    {
      "name": "Pune to Igatpuri Taxi Fare",
      "description": "Get affordable and transparent Pune to Igatpuri Taxi Fare with no hidden charges. Fare is calculated based on distance, car type, and trip duration. We provide clear fare breakdowns before you book, along with special offers for round trips and off-peak travel. Our competitive pricing ensures you receive value without compromising on service quality or safety standards."
    },
    {
      "name": "Pune Igatpuri Private Taxi",
      "description": "Opt for a Pune Igatpuri Private Taxi for a personalized travel experience. Avoid the hassle of shared cabs and public transport, and enjoy exclusive use of a comfortable vehicle driven by a courteous professional. Ideal for families, couples, or business travelers seeking privacy and flexibility during their journey to the peaceful hills of Igatpuri."
    },
    {
      "name": "Igatpuri Cab Packages Pune",
      "description": "Our Igatpuri Cab Packages from Pune are thoughtfully curated to meet diverse travel needs — from romantic getaways to family vacations and group tours. Packages include pick-up, sightseeing options en route, stopovers, and return trips, all at discounted bundle rates. Customize your package for maximum value and convenience, with the option to include hotel pickups or sightseeing at Nashik or Bhandardara."
    },
    {
      "name": "Pune to Igatpuri One Way Cab",
      "description": "Looking for a one-way trip? Book a Pune to Igatpuri One Way Cab and pay only for what you use. This service is perfect for travelers relocating, solo adventurers, or guests being dropped off at resorts in Igatpuri. Choose your preferred vehicle class, get real-time driver details, and experience a seamless trip with assured pick-up timing and safe drop-off."
    },
    {
      "name": "Igatpuri Taxi Charges Pune",
      "description": "Know your Igatpuri Taxi Charges from Pune before you ride. Our transparent pricing policy ensures that you’re not surprised by last-minute additions. You’ll receive a detailed invoice covering base fare, tolls, driver allowance (if applicable), and any extras upfront. Charges vary depending on car category and journey type, with seasonal discounts available."
    },
    {
      "name": "Pune to Igatpuri Taxi Hire",
      "description": "Pune to Igatpuri Taxi Hire service offers a convenient, fast, and cost-effective travel option for all types of travelers. Hire by the hour, by the day, or for longer tours. Ideal for tourists, spiritual travelers visiting Vipassana centers, or weekend adventurers, our taxis are available 24x7 with verified drivers and real-time GPS tracking for complete security."
    },
    {
      "name": "Igatpuri Cab for Weekend Trips Pune",
      "description": "Plan the perfect weekend escape with our Igatpuri Cab for Weekend Trips from Pune. Whether you're planning to trek, relax at a resort, or visit vineyards nearby, our weekend cab services offer custom itineraries, reliable scheduling, and special weekend rates. Enjoy breathtaking views en route with pit stops of your choice and return safely the next day or after a couple of days of rejuvenation."
    },
    {
      "name": "Pune to Igatpuri Outstation Taxi",
      "description": "Our Pune to Igatpuri Outstation Taxi is specially designed for intercity travelers needing round-trip or one-way services. Benefit from experienced drivers, clean and sanitized vehicles, and flexible return options. Whether you're visiting Igatpuri’s meditation centers, nature resorts, or adventure camps, our outstation taxi service is ideal for all age groups and travel preferences."
    },
    {
      "name": "Igatpuri Taxi with Driver Pune",
      "description": "All our Igatpuri Taxis from Pune come with courteous, experienced, and background-verified drivers who ensure your trip is not only comfortable but also safe and informative. Drivers are familiar with tourist spots, best eateries, and photo-friendly locations. Enjoy local insights, efficient navigation, and respectful hospitality throughout your trip."
    },
    {
      "name": "Taxi Service Pune to Igatpuri",
      "description": "Reiterating our core offering, this Taxi Service from Pune to Igatpuri ensures you travel with complete peace of mind. Be it for tourism, business, spiritual retreats, or visiting loved ones, our punctual service, diverse fleet, and round-the-clock customer support make this one of the most dependable cab services on the Pune-Igatpuri route."
    }
  ],
  "tableData": [
    ["Pune to Igatpuri Cab Service", "Igatpuri Taxi from Pune"],
    ["Pune Igatpuri Taxi Booking", "Taxi Service Pune to Igatpuri"],
    ["Igatpuri Cab Rental Pune", "Pune to Igatpuri Taxi Fare"],
    ["Pune Igatpuri Private Taxi", "Igatpuri Cab Packages Pune"],
    ["Pune to Igatpuri One Way Cab", "Igatpuri Taxi Charges Pune"],
    ["Pune to Igatpuri Taxi Hire", "Igatpuri Cab for Weekend Trips Pune"],
    ["Pune to Igatpuri Outstation Taxi", "Igatpuri Taxi with Driver Pune"],
    ["Taxi Service Pune to Igatpuri", "—"]
  ],


      "whychoose": [
    {
      "WhyChooseheading": "Luxurious Premium Cab Service in Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers top-notch premium cab services with luxury vehicles for a comfortable and stylish ride."
    },
    {
      "WhyChooseheading": "High-End Vehicles for Ultimate Comfort",
      "WhyChoosedescription": "Choose from premium sedans and SUVs that are well-maintained and equipped with modern amenities."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs for a Smooth Experience",
      "WhyChoosedescription": "Our experienced and courteous drivers ensure a safe, timely, and pleasant journey."
    },
    {
      "WhyChooseheading": "Clean and Sanitized Fleet for Your Safety",
      "WhyChoosedescription": "Travel worry-free with our regularly sanitized luxury vehicles."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
      "WhyChoosedescription": "Customize your travel plans with flexible packages designed to meet your premium service needs."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances for hassle-free travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Seamless Booking",
      "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings and special requests."
    },
    {
      "WhyChooseheading": "Ideal for Corporate Travel, Special Occasions, and Luxury Tours",
      "WhyChoosedescription": "Perfect for business trips, weddings, and other premium travel needs in Pune."
    }
  ]





































    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer premium cab services in Pune?',
        answer: 'Yes, Platinum24 Cabs provides premium cab services in Pune featuring luxury and high-end vehicles for a comfortable and stylish ride.',
    },
    {
        question: 'How can I book a premium cab in Pune with Platinum24 Cabs?',
        answer: 'You can book your premium cab easily via our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of premium vehicles are available in Pune?',
        answer: 'We offer luxury sedans, SUVs, and executive cars from top brands to cater to your premium travel needs.',
    },
    {
        question: 'Are the premium cab drivers experienced and professional?',
        answer: 'Yes, our premium cab drivers are highly trained, professional, and committed to providing a superior travel experience.',
    },
    {
        question: 'Can I book premium cabs for airport transfers and corporate events?',
        answer: 'Absolutely! Our premium cab services are ideal for airport pickups, corporate travel, and special occasions.',
    },
    {
        question: 'Are premium cabs available for hourly and outstation bookings?',
        answer: 'Yes, you can book premium cabs for hourly rentals, local trips, or outstation journeys from Pune.',
    },
    {
        question: 'What safety and hygiene measures are followed in premium cabs?',
        answer: 'All premium vehicles are regularly sanitized, and drivers adhere to strict safety protocols for your protection.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for premium cab rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points anywhere within Pune or beyond.',
    },
    {
        question: 'Are there flexible payment options for premium cab services?',
        answer: 'Yes, we accept multiple payment methods including credit/debit cards, digital wallets, and corporate billing options.',
    },
    {
        question: 'Does Platinum24 Cabs provide 24x7 premium cab service in Pune?',
        answer: 'Yes, our premium cab services are available 24x7 to meet your travel needs anytime.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Siddharth Malhotra',
        feedback: 'The premium cab service by Platinum24 Cabs was exceptional. The vehicle was luxurious and the driver was professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Nisha Kapoor',
        feedback: 'I booked a premium cab for my corporate event and was very impressed with the service and comfort provided.',
        rating: 5,
    },
];




















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];






const igatpuriTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable taxi service from Pune to Igatpuri offering affordable and comfortable cab rentals for weekend trips, outstation travel, and private bookings with experienced drivers.",
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Igatpuri"
    }
  ],
  "serviceType": [
    "Pune to Igatpuri Cab Service",
    "Igatpuri Taxi from Pune",
    "Pune Igatpuri Taxi Booking",
    "Taxi Service Pune to Igatpuri",
    "Igatpuri Cab Rental Pune",
    "Pune to Igatpuri Taxi Fare",
    "Pune Igatpuri Private Taxi",
    "Igatpuri Cab Packages Pune",
    "Pune to Igatpuri One Way Cab",
    "Igatpuri Taxi Charges Pune",
    "Pune to Igatpuri Taxi Hire",
    "Igatpuri Cab for Weekend Trips Pune",
    "Pune to Igatpuri Outstation Taxi",
    "Igatpuri Taxi with Driver Pune",
    "Taxi Service Pune to Igatpuri"
  ],
  "telephone": "+91-XXXXXXXXXX"
};








    return (
        <div>
<Helmet>
  <title>Pune to Igatpuri Taxi Service | Reliable Cab Booking Pune to Igatpuri</title>
  <meta
    name="description"
    content="Reliable taxi service from Pune to Igatpuri offering affordable and comfortable cab rentals for weekend trips, outstation travel, and private bookings with experienced drivers."
  />
  <meta
    name="keywords"
    content="Pune to Igatpuri Cab Service, Igatpuri Taxi from Pune, Pune Igatpuri Taxi Booking, Taxi Service Pune to Igatpuri, Igatpuri Cab Rental Pune, Pune to Igatpuri Taxi Fare, Pune Igatpuri Private Taxi, Igatpuri Cab Packages Pune, Pune to Igatpuri One Way Cab, Igatpuri Taxi Charges Pune, Pune to Igatpuri Taxi Hire, Igatpuri Cab for Weekend Trips Pune, Pune to Igatpuri Outstation Taxi, Igatpuri Taxi with Driver Pune, Taxi Service Pune to Igatpuri"
  />
  <script type="application/ld+json">
    {JSON.stringify(igatpuriTaxiSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/57.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetolgatpuritaxi;